<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4 tw-relative">
    <div mat-dialog-title class="matp-dialog-title">
      {{ "タグ" }}{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="tw-w-full !tw-pt-2">
      <div class="tag-edit-layout">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>タグ名</mat-label>
          <input
            matInput
            formControlName="tagName"
            name="tagName"
            [required]="!updating"
          />
          <mat-error *ngIf="formGroup.controls.tagName.errors?.['required']">
            タグ名を入力してください。
          </mat-error>
          <mat-error *ngIf="formGroup.controls.tagName.errors?.['maxlength']">
            32文字以内で入力してください。
          </mat-error>
        </mat-form-field>
        <div class="color-preview-layout">
          <section class="color-selection">
            <div class="color-label tw-mb-2">色</div>
            <div class="color-controls">
              <div
                class="preset-colors"
                role="group"
                aria-label="プリセットカラー"
              >
                @for (preset of presetColors; track preset.hex) {
                  <button
                    type="button"
                    class="color-swatch"
                    [class.selected]="isSelected(preset.hex)"
                    [style.background-color]="preset.hex"
                    [attr.aria-label]="preset.name + ' ' + preset.hex"
                    [attr.aria-pressed]="isSelected(preset.hex)"
                    (click)="selectColor(preset.hex)"
                  >
                    @if (isSelected(preset.hex)) {
                      <mat-icon aria-hidden="true">check</mat-icon>
                    }
                  </button>
                }
              </div>
              <div class="custom-colors">
                @if (customColor; as customHex) {
                  <button
                    type="button"
                    class="color-swatch"
                    [style.background-color]="customHex"
                    [attr.aria-label]="'任意の色 ' + customHex"
                    [attr.aria-pressed]="isSelected(customHex)"
                    (click)="selectColor(customHex)"
                  >
                    @if (isSelected(customHex)) {
                      <mat-icon
                        aria-hidden="true"
                        [style.color]="tagStyle(customHex).color"
                        >check</mat-icon
                      >
                    }
                  </button>
                }
                <div class="custom-color" title="その他の色">
                  <mat-icon aria-hidden="true">add</mat-icon>
                  <input
                    #customColorInput
                    type="text"
                    [value]="formGroup.controls.color.value"
                    aria-label="その他の色を選択"
                    readonly
                  />
                </div>
              </div>
            </div>
          </section>
          <section class="preview-panel">
            <div>プレビュー</div>
            <div class="preview-tag">
              <span
                class="preview-tag-label tw-inline-block tw-rounded tw-p-1"
                [ngStyle]="tagStyle(formGroup.controls.color.value)"
                [attr.title]="formGroup.controls.tagName.value || 'タグ名'"
                >{{ formGroup.controls.tagName.value || "タグ名" }}</span
              >
            </div>
          </section>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
